import { Button, Flex, Modal } from 'antd';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
import { type CustomModalProps } from './CustomModal';

type ConfirmModalProps = {
  data?: any;
  type?: any;
  open?: boolean;
  loading?: boolean;
  buttonName?: string;
  children?: ReactNode;
  disabled?: boolean;
  handleSubmit?: (checked: boolean) => void | Promise<void>;
  wrapperClassName?: string;
  classNames?: { wrapper?: string; root?: string; titleWrapper?: string };
  cancelButton?: string;
} & CustomModalProps;

export default function ConfirmationModal({
  open,
  loading,
  buttonName,
  title,
  subTitle,
  children,
  handleClose,
  handleSubmit,
  disabled = false,
  wrapperClassName,
  classNames,
  cancelButton = 'Cancel',
}: ConfirmModalProps) {
  return (
    <>
      <Modal
        width={400}
        open={open}
        footer={null}
        closable={true}
        centered={true}
        className={cn('custom-modal')}
        rootClassName="custom-bg-modal"
        onCancel={() => handleClose()}
      >
        <div className={cn('p-4', wrapperClassName)}>
          <div className="flex justify-center items-center w-full">
            <div
              className={cn(
                'flex flex-col items-center gap-4 text-center',
                classNames?.titleWrapper,
              )}
            >
              <div className="text-white text-2xl font-bold">{title}</div>

              <div className="text-white text-lg font-normal w-full">
                {subTitle}
              </div>
            </div>
          </div>
          <div>{children}</div>

          <Flex align="center" justify="center" gap={16} className="mt-10">
            <Button
              size="middle"
              htmlType="button"
              className="min-w-[120px] w-full h-10 !border-teal-500 !text-teal-500 !bg-transparent !font-semibold"
              onClick={handleClose}
            >
              {cancelButton}
            </Button>
            <Button
              size="middle"
              type="primary"
              color="primary"
              loading={loading}
              disabled={disabled}
              className="min-w-[120px]  w-full h-10 !bg-teal-500 !text-neutral-700 !border-none !font-semibold"
              onClick={() => handleSubmit?.(true)}
            >
              {buttonName}
            </Button>
          </Flex>
        </div>
      </Modal>
    </>
  );
}
